import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {BookingPrice} from '../classes/BookingPrice';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class BookingPriceService {

  constructor(private httpClient: HttpClient) {
  }

  public getAll(): Observable<BookingPrice[]> {
    return this.httpClient.get<BookingPrice[]>(`${environment.backendApiUrl}/v1/booking/prices`, httpOptions);
  }

  public getByRoom(roomId: number): Observable<BookingPrice[]> {
    return this.httpClient.get<BookingPrice[]>(`${environment.backendApiUrl}/v1/booking/prices/room/` + roomId, httpOptions);
  }

  public addOrEdit(bookingPrice: BookingPrice): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/booking/prices`, bookingPrice, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/booking/prices/` + id, httpOptions);
  }

  public getCurrentPrices(): Observable<BookingPrice[]> {
    return this.httpClient.get<BookingPrice[]>(`${environment.backendApiUrl}/v1/booking/prices/current`, httpOptions);
  }

  public getCurrentPrice(orderType: string): Observable<BookingPrice> {
    return this.httpClient.get<BookingPrice>(`${environment.backendApiUrl}/v1/booking/prices/current/` + orderType, httpOptions);
  }
}
